import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Button,
  Typography,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Container,
  Chip,
  ButtonGroup,
  Divider,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Alert,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { fetchUsers } from "../utils/api";
import ResetPasswordForm from "./ResetPasswordForm";

export default function BranchCards() {
  const [users, setUsers] = useState([]);
  const [registerDialogOpen, setRegisterDialogOpen] = useState(false);
  const [registerDialog, setRegisterDialog] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleOpenSnackbar = () => setSnackbarOpen(true);
  const handleCloseSnackbar = () => setSnackbarOpen(false);

  const handleOpenRegisterDialog = () => setRegisterDialogOpen(true);
  const handleCloseRegisterDialog = () => setRegisterDialogOpen(false);

  useEffect(() => {
    fetchUsersData();
  }, []);

  const handleResetPassword = (user) => {
    setRegisterDialog(
      <>
        <DialogTitle id="alert-dialog-title">Reset Password</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseRegisterDialog}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <Close />
        </IconButton>
        <DialogContent>
          <ResetPasswordForm
            user={user}
            done={() => {
              handleCloseRegisterDialog();
              fetchUsersData();
            }}
            setSnackbarMessage={setSnackbarMessage}
            setSnackbarSeverity={setSnackbarSeverity}
            handleOpenSnackbar={handleOpenSnackbar}
          />
        </DialogContent>
      </>
    );
    handleOpenRegisterDialog();
  };

  const fetchUsersData = async () => {
    try {
      const data = await fetchUsers();
      setUsers(data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
    }
  };

  return (
    <>
      <Container maxWidth="sm" sx={{ padding: 2 }}>
        <TableContainer component={Paper} elevation={3}>
          <Table size="small">
            <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
              <TableRow>
                <TableCell>Users</TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((row) => {
                return (
                  <TableRow
                    key={row._id}
                    sx={{
                      "&:last-child td, &:last-child th": {
                        border: 0,
                      },
                    }}
                  >
                    <TableCell>{row.username}</TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => handleResetPassword(row)}
                      >
                        Reset password
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
      <Dialog
        open={registerDialogOpen}
        onClose={handleCloseRegisterDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {registerDialog}
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
